import { motion } from 'framer-motion'
import GitHubCalendar from 'react-github-calendar'
import { useEffect, useState } from 'react'

function Github() {
  const [blockSize, setBlockSize] = useState(15)
  const [blockMargin, setBlockMargin] = useState(5)
  const [fontSize, setFontSize] = useState(16)

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 640) {
        // Mobile
        setBlockSize(8)
        setBlockMargin(3)
        setFontSize(12)
      } else if (window.innerWidth < 1024) {
        // Tablet
        setBlockSize(12)
        setBlockMargin(4)
        setFontSize(14)
      } else {
        // Desktop
        setBlockSize(15)
        setBlockMargin(5)
        setFontSize(16)
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-center"
    >
      <h1 className="text-3xl md:text-4xl font-bold mb-8">
        Days I <span className="text-gradient">Code</span>
      </h1>
      
      <div className="flex justify-center w-full overflow-x-auto px-4">
        <div className="glass-effect rounded-xl p-4 md:p-8 w-full max-w-full">
          <div className="w-full overflow-x-auto">
            <GitHubCalendar
              username="Benedict-Kpaduwa"
              blockSize={blockSize}
              blockMargin={blockMargin}
              color="#a855f7"
              fontSize={fontSize}
            />
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default Github

